<template>
   <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="25px" height="25px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
    <path fill="#269CD8" d="M38.036,35.001L31.2,28.164c2.339-2.895,3.747-6.571,3.747-10.574c0-9.296-7.563-16.858-16.858-16.858
        c-9.296,0-16.858,7.563-16.858,16.858c0,9.297,7.563,16.859,16.858,16.859c3.492,0,6.739-1.067,9.432-2.894l6.979,6.98
        c0.488,0.488,1.128,0.732,1.768,0.732s1.279-0.244,1.768-0.732C39.013,37.561,39.013,35.978,38.036,35.001z M6.231,17.59
        c0-6.538,5.32-11.858,11.858-11.858s11.858,5.32,11.858,11.858c0,6.539-5.319,11.859-11.858,11.859S6.231,24.129,6.231,17.59z"/>
    </svg>
</template>